<template>
  <modal :show="show" @change="$emit('change',$event); openSubscribeEpdModal()" width="550">
    <template v-slot:header>
      <span>Информация</span>
    </template>
    <template v-slot:main>
      <div class="modal-info text-center mx-7">
        <p class="text-center pt-5 pb-5 pl-4 pr-4 mb-0">
          Подключение услуги «Электронная квитанция» по данному лицевому счету недоступно,
          поскольку владельцем лицевого счета является другой потребитель
        </p>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from "../common/Modal";
import { mapGetters, mapState } from "vuex";

export default {
  name: "ModalIndicationInfo",
  components: { Modal },
  model: {
    prop: "show",
    event: "change"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    currentMonth: new Date().getMonth()
  }),
  computed: {},
  methods: {
    openSubscribeEpdModal() {
      console.log("openSubscribeModal in component");
      this.$emit("openSubscribeModal");
    }
  },
  created() {},
  watch: {}
};
</script>

<style lang="scss">
</style>
